module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "show": _vm.modalShow,
      "backdrop": _vm.modalBackdrop,
      "effect": "zoom",
      "width": "400"
    },
    on: {
      "update:show": function($event) {
        _vm.modalShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "fas fa-minus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Remove Entry Point\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._v("\n      Are you sure you want to remove the entry point " + _vm._s(_vm.selectedKey) + " from the App Config?\n      "), _c('p', {
    staticClass: "text-danger"
  }, [_vm._v("This action cannot be undone.")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalCloseCallback
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modalRemoveCallback
    }
  }, [_vm._v("Remove")])])]), _vm._v(" "), (_vm.showConfigData) ? _c('div', [_c('vue-good-table', {
    attrs: {
      "title": "Configured entry points",
      "columns": _vm.columns,
      "rows": _vm.config.entryPointList,
      "sort-options": {
        enabled: true,
        initialSortBy: {
          field: 'key',
          type: 'asc'
        }
      },
      "search-options": {
        enabled: true
      },
      "paginationOptions": {
        enabled: true
      },
      "rowStyleClass": _vm.tableRowClass,
      "styleClass": "vgt-table striped bordered table-hover",
      "lineNumbers": true
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'key') ? _c('span', [_vm._v(_vm._s(props.row.key))]) : _vm._e(), _vm._v(" "), (props.column.field == 'value') ? _c('span', [_vm._v(_vm._s(props.row.value))]) : _vm._e(), _vm._v(" "), (props.column.label == 'Actions') ? _c('span', [_c('button', {
          staticClass: "btn btn-sm btn-info",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.btnUpdateEntryPoint(props.row.key, props.row.value)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-edit",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Update\n          ")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-sm btn-danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.btnRemoveEntryPoint(props.row.key, props.row.value)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-minus-circle"
        }), _vm._v(" Remove\n          ")])]) : _vm._e()]
      }
    }], null, false, 3197696587)
  })], 1) : _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "id": "timeouts-info",
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("No Entry Points.")]), _c('br'), _vm._v("\n    There are no entry point timeouts set for this app\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67672014","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppConfigEntryPoint.vue
// module id = 593
// module chunks = 2